import { createContext } from 'react';

const DefaultContext = createContext({});

export default DefaultContext;
